import { useQuery } from '@tanstack/react-query'
import { searchDayLocks } from '@lib/api'
import { dayLockKeys } from '@lib/keys'
import { DateTime } from 'luxon'

interface Options {
  userId: number
  start: DateTime
  end: DateTime
}

export const useDayLocks = ({ userId, start, end }: Options) => {
  return useQuery(dayLockKeys.searchByUser(userId, start, end), () =>
    searchDayLocks(userId, start, end),
  )
}
